import React from 'react';
import './styles.scss';
import Button from '../../../components/molecules/buttons';
import { Snack, SodaCan } from '../../../components/atoms/icons';
import Stepper from '../../../components/molecules/steppers';
import Forms from '../../../components/molecules/forms';
import useCustomerSupport from './hooks';
import RenderTableService from './table/service';
import RenderTableRefund from './table/refund';
import LandingHeader from '../../../components/layout/header/landing';

function CustomerSupport() {
  const {
    step, navigate, service, refund,
  } = useCustomerSupport();

  const renderVM = (type: number | null, deviceId: string | null, clientName: string | null): React.ReactElement => (
    <div className="d-flex align-items-center fz-14 my-2" style={{ minWidth: 270 }}>
      <div>
        {type === 0 ? <SodaCan width={17} /> : <Snack width={21} />}
      </div>
      <div className="ms-2">
        <div className="fw-bold">{deviceId ?? '-'}</div>
        <div>{clientName ?? '-'}</div>
      </div>
    </div>
  );

  return (
    <div className="py-4">
      <LandingHeader title="Customer Support" />
      <div className="px-4 px-xl-5">
        <div className="row">
          <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12">
            <Stepper.Slide
              step={step.current}
              setStep={step.setCurrent}
              labels={['Service Request', 'Refund Request']}
            />
          </div>
          <div className="col-xxl-2 offset-xxl-4 col-xl-3 offset-xl-3 col-lg-3 offset-lg-1 col-md-6 col-sm-12 mb-4 mb-md-0">
            <div className={step.current === 0 ? '' : 'd-none'}>
              <Forms.ReactSelect.Default
                id="status"
                placeholder="Choose Status"
                options={service.options}
                value={service.current}
                onChange={(e) => {
                  if (e) {
                    service.setCurrent(e);
                    service.setPage(1);
                  }
                }}
                isSearchable={false}
                isTextIcon
              />
            </div>
            <div className={step.current === 1 ? '' : 'd-none'}>
              <Forms.ReactSelect.Default
                id="status"
                placeholder="Choose Status"
                options={refund.options}
                value={refund.current}
                onChange={(e) => {
                  if (e) {
                    refund.setCurrent(e);
                    refund.setPage(1);
                  }
                }}
                isSearchable={false}
                isTextIcon
              />
            </div>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-4 offset-md-8 offset-lg-0 mb-4 mb-lg-0 col-sm-12">
            <Button.Default
              id="addRoute"
              type="button"
              label={step.current === 0 ? 'Add Service Request' : 'Add Refund Request'}
              onClick={step.current === 0
                ? () => navigate.service()
                : () => navigate.refund()}
            />
          </div>
        </div>
        <Forms.Search placeholder="Search by ticket number, Machine ID, or technician" />
        <div className="w-100 mt-4">
          {step.current === 0 && (
            <RenderTableService
              status={service.current?.value ?? ''}
              page={{ current: service.page, setCurrent: service.setPage }}
              renderVM={renderVM}
            />
          )}
          {step.current === 1 && (
            <RenderTableRefund
              status={refund.current?.value}
              page={{ current: refund.page, setCurrent: refund.setPage }}
              renderVM={renderVM}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerSupport;
